import { render } from "./PhoneOtp.vue?vue&type=template&id=2d50c452&ts=true"
import script from "./PhoneOtp.vue?vue&type=script&lang=ts"
export * from "./PhoneOtp.vue?vue&type=script&lang=ts"

import "./PhoneOtp.vue?vue&type=style&index=0&id=2d50c452&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__